import { IAction } from "../../../interface/action.interface";
import { TrackedListColumns } from "../enum/tracked-list-columns";
import { ITrackedListDto } from "../interface/dto/tracked-lists.dto";

export enum TrackedListActionTypes {
    TRACKED_LIST_LOAD_LISTS = "TRACKED_LIST_LOAD_LISTS",
    TRACKED_LIST_SET_SEARCHQUERY = "TRACKED_LIST_SET_SEARCHQUERY",
    TRACKED_LIST_LOAD_LISTS_SUCCESS = "TRACKED_LIST_LOAD_LISTS_SUCCESS",
    TRACKED_LIST_LOAD_LISTS_ERROR = "TRACKED_LIST_LOAD_LISTS_ERROR",
    TRACKED_LIST_SET_PAGINATION = "TRACKED_LIST_SET_PAGINATION",
    TRACKED_LIST_SET_SORTING = "TRACKED_LIST_SET_SORTING",
    TRACKED_LIST_TRACK = "TRACKED_LIST_TRACK",
    TRACKED_LIST_TRACK_SUCCESS = "TRACKED_LIST_TRACK_SUCCESS",
    TRACKED_LIST_TRACK_ERROR = "TRACKED_LIST_TRACK_ERROR",
    TRACKED_LIST_INIT = "TRACKED_LIST_INIT",
}

export interface ITrackedListSetSearchQueryAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_SET_SEARCHQUERY;
    payload: string;
}

export interface ITrackedListLoadAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS;
}

export interface ITrackedListLoadSuccessAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS_SUCCESS;
    payload: ITrackedListDto;
}

export interface ITrackedListLoadErrorAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS_ERROR;
    payload: { error: string };
}

export interface ITrackedListTrackSuccessAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_TRACK_SUCCESS;
}

export interface ITrackedListTrackErrorAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_TRACK_ERROR;
    payload: { error: string };
}

export interface ITrackedListSetPaginationAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_SET_PAGINATION;
    payload: {
        currentPage: number;
        itemsPerPage: number;
    };
}

export interface ITrackedListSetSortingAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_SET_SORTING;
    payload: {
        column: TrackedListColumns;
        order: "asc" | "desc";
    };
}

export interface ITrackedListToggleAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_TRACK;
    payload: {
        id: number;
        track: boolean;
    };
}

export interface ITrackedListInitAction extends IAction {
    type: TrackedListActionTypes.TRACKED_LIST_INIT;
}

export const trackedListInitAction = () => ({
    type: TrackedListActionTypes.TRACKED_LIST_INIT,
});

export const trackedListTrackAction = (
    id: number,
): ITrackedListToggleAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_TRACK,
    payload: {
        id,
        track: true,
    },
});

export const trackedListUntrackAction = (
    id: number,
): ITrackedListToggleAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_TRACK,
    payload: {
        id,
        track: false,
    },
});

export const trackedListSetFiltersAction = (
    searchQuery: string,
): ITrackedListSetSearchQueryAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_SET_SEARCHQUERY,
    payload: searchQuery,
});

export const trackedListLoadAction = (): ITrackedListLoadAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS,
    payload: {},
});

export const trackedListTrackSuccessAction =
    (): ITrackedListTrackSuccessAction => ({
        type: TrackedListActionTypes.TRACKED_LIST_TRACK_SUCCESS,
        payload: {},
    });

export const trackedListTrackErrorAction = (
    error: string,
): ITrackedListTrackErrorAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_TRACK_ERROR,
    payload: { error },
});

export const trackedListLoadSuccessAction = (
    data: ITrackedListDto,
): ITrackedListLoadSuccessAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS_SUCCESS,
    payload: data,
});

export const trackedListLoadErrorAction = (
    error: string,
): ITrackedListLoadErrorAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS_ERROR,
    payload: { error },
});

export const trackedListSetPaginationAction = (
    currentPage: number,
    itemsPerPage: number,
): ITrackedListSetPaginationAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_SET_PAGINATION,
    payload: { currentPage, itemsPerPage },
});

export const trackedListSetSortingAction = (
    column: TrackedListColumns,
    order: "asc" | "desc",
): ITrackedListSetSortingAction => ({
    type: TrackedListActionTypes.TRACKED_LIST_SET_SORTING,
    payload: { column, order },
});

export type ITrackedListActions =
    | ITrackedListSetSearchQueryAction
    | ITrackedListLoadAction
    | ITrackedListLoadSuccessAction
    | ITrackedListLoadErrorAction
    | ITrackedListSetPaginationAction
    | ITrackedListSetSortingAction
    | ITrackedListToggleAction
    | ITrackedListTrackErrorAction
    | ITrackedListInitAction
    | ITrackedListTrackSuccessAction;
